module.exports = __webpack_public_path__ + "img/Star.07a7cfd6.svg";